import LoaderHlsjs from '../PlayerLoaders/LoaderHlsjs';
import JwPlayer from './Players/JwPlayer';
import LoaderShaka from '../PlayerLoaders/LoaderShaka';
import LoaderTheo from '../PlayerLoaders/LoaderTheo';
import LoaderBitmovin from '../PlayerLoaders/LoaderBitmovin';
import HlsJs from './Players/Hlsjs';
import Shaka from './Players/Shaka';
import VideoJs from './Players/VideoJs';
import Clappr from './Players/Clappr';
import Theoplayer from './Players/Theoplayer';
import Dash from './Players/Dash';
import LoaderDash from '../PlayerLoaders/LoaderDash';
import Flowplayer from './Players/Flowplayer';
import Bitmovin from './Players/Bitmovin';
import LoaderVhs from '../PlayerLoaders/LoaderVhs';
/**
 * @class
 * @description Container class to keep all the loaders and adapters.
 * A loader is a piece of code that is injected in the players.
 * Adapters simplifies the integrations and are player-specific.
 * @exports Adapters
 */
export default class Adapters {
    /**
     * Constructs Adapters class.
     * @param {CdnBalancer} engine Cdn balancer base object.
     */
    constructor(engine) {
        this._loaders = {
            LoaderHlsjs: LoaderHlsjs,
            LoaderShaka: LoaderShaka,
            LoaderTheo: LoaderTheo,
            LoaderDash: LoaderDash,
            LoaderBitmovin: LoaderBitmovin,
            LoaderVhs: LoaderVhs
        };
        this.JwPlayer = JwPlayer;
        this.VideoJs = VideoJs;
        this.Clappr = Clappr;
        this.HlsJs = HlsJs;
        this.Shaka = Shaka;
        this.Theoplayer = Theoplayer;
        this.Dash = Dash;
        this.Flowplayer = Flowplayer;
        this.Bitmovin = Bitmovin;
        for (const loader in this._loaders) {
            this._loaders[loader]._engine = engine;
        }
        [
            this.Clappr,
            this.VideoJs,
            this.JwPlayer,
            this.HlsJs,
            this.Shaka,
            this.Theoplayer,
            this.Dash,
            this.Flowplayer,
            this.Bitmovin
        ].forEach((adapter) => {
            adapter._adapters = this;
        });
    }
    /**
     * Returns an object with all the loaders: the part of the code to be injected in the players to modify
     * their behaviour.
     * @returns {Object} Object with the loaders.
     * @public
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getLoaders() {
        return this._loaders;
    }
}
